export default '/build/0d639e4a.png'